<script lang="ts" context="module">

    const cardBackfaceImagesMap = {
        'BingoMex'              : '/images/card_backface_mex.jpg',
        'XMas'                  : '/images/card_backface_mex.jpg',
        'Football'              : '/images/card_backface_mex.jpg',
        'BingoCartoon'          : '/images/card_backface_mex.jpg',
        'Movies'                : '/images/card_backface_mex.jpg',
        'MoviesKids'            : '/images/card_backface_animals.jpg',
        'BingoAnimals'          : '/images/card_backface_animals.jpg',
        'Halloween'             : '/images/card_backface_mex.jpg',
        'Superheroes'           : '/images/card_backface_mex.jpg',
        'Cartoon'               : '/images/card_backface_mex.jpg'
    };

</script>
<script lang="ts">
    
    import { getContext } from "svelte";
    import type { GameType } from "../../global";
    import type { Board } from "../../Model/Board";
    import type { Cell } from "../../Model/Cell";
    import type { Game } from "../../Model/Game";
    import { boardsService } from "../../Services";
    import GameCard from "../Game/GameCard.svelte";
    import AspectKeeper from "../Shared/AspectKeeper.svelte";
    import Watch from "../Shared/Watch.svelte";

    export let board: Board;
    export let forceShowCards = false;
    export let gameType: GameType;

    // $: console.log(cardBackfaceImagesMap[gameType]);

    const getGame: () => Game = getContext('getGame');
    const aspectRatio = 512 / 321;

    function onClick(cell: Cell): void {

        if (cell.isChecked) {
            return;
        }

        const game = getGame();

        if (!game.hasNumber(cell.number)) {
            //TODO: Animación de número no ha salido
            return;
        }

        boardsService.checkCell(board.id, cell.number);
    }

</script>

<AspectKeeper ratio={aspectRatio}>
    <div class="cells notranslate" style="--backface-image: url({cardBackfaceImagesMap[gameType]});">
        {#each board.cells as cell}
            <Watch state={cell.checked} let:value={checked}>
                <div class="card" on:click={() => onClick(cell)}>
                    <div class="front" class:checked={checked && !forceShowCards}>
                        <GameCard number={cell.number} {gameType} />
                    </div>
                    <div class="back" class:checked={checked && !forceShowCards}></div>
                </div>
            </Watch>
        {/each}
    </div>
</AspectKeeper>

<style lang="scss">

    .cells {
        height: 100%;
        display: grid;
        grid-template-columns: repeat(4, auto);
        grid-template-rows: repeat(4, auto);
        gap: 0.8vw;
    }

    .card {
        position: relative;
        height: 100%;
        perspective: 400px;

        .front, .back {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            backface-visibility: hidden;
            transition: transform 0.5s;
        }

        .front {
            transform: translateZ(1px);

            &.checked {
                transform: translateZ(0) rotateY(-180deg);
            }
        }

        .back {
            background-color: #fff;
            background-image: var(--backface-image);
            background-position: center;
            background-size: 100% 100%;
            background-repeat: no-repeat;
            transform: translateZ(0) rotateY(-180deg);

            &.checked {
                transform: translateZ(1px) rotateY(-360deg);
            }
        }
    }

</style>
